import React from 'react';
import Poker from './components/Poker';

const App: React.FC = () => {
  return (
      <Poker />
  );
};

export default App;
